import { render, staticRenderFns } from "./ViewEmpty.vue?vue&type=template&id=53db8a34&scoped=true&"
import script from "./ViewEmpty.vue?vue&type=script&lang=js&"
export * from "./ViewEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmpty.vue?vue&type=style&index=0&id=53db8a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db8a34",
  null
  
)

export default component.exports